export default __webpack_public_path__ + "static/9-election-cycle-cf86ccccb759ba49c675be6b90d53b92.jpg";